var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { style: { width: "100%", margin: "0px auto", marginTop: "25px" } },
    [
      _c(
        "w-col",
        { attrs: { sm: "12", md: "8" } },
        [
          _vm.hasBillingAddress && !_vm.editInvoiceAddress
            ? _c("app-billing-address", {
                staticClass: "mb",
                attrs: { address: _vm.address },
                on: {
                  edit: function ($event) {
                    _vm.editInvoiceAddress = !_vm.editInvoiceAddress
                  },
                },
              })
            : _c("app-billing-address-edit", {
                staticClass: "mb",
                on: {
                  update: function ($event) {
                    return _vm.onBillingAddressUpdate($event)
                  },
                },
              }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { sm: "12", md: "4" } },
        [
          _vm.price
            ? _c("app-activation-card", {
                attrs: {
                  plan: _vm.plan,
                  mandate: _vm.mandate,
                  price: _vm.price,
                  "discount-code": _vm.discountCode,
                  "discount-code-allowed": "",
                },
                on: {
                  "new-discount-code": function ($event) {
                    return _vm.onNewDiscountCode($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }